import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';
import { SucursalesBancarias } from 'types/SucursalesBancarias';

export async function getSucursalesBancarias(): Promise<SucursalesBancarias[]> {
  try {
    const url = new URL(`${ config.baseUrl }/sucursales-bancarias`);

    type Response = APIResponse<SucursalesBancarias[]>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      throw new Error('Ocurrió un problema de conexión al momento de intentar recuperar las sucursales bancarias. ');
    }

    const content = await response.json() as Response;
    if (content.status !== 'ok' || !content.payload) {
      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las sucursales bancarias. ');
    }

    return content.payload;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
